import React from 'react';
import './Textarea.css';

const Textarea = props => (
	<textarea
		{...props}
		className={`Textarea ${props.className || ''}`}
	/>
);

export default Textarea;


// WEBPACK FOOTER //
// ./src/widgets/Textarea.js